// extracted by mini-css-extract-plugin
export default {"img_text_header":"PrivacyPolicy_img_text_header__klXpa","privacy_text":"PrivacyPolicy_privacy_text__rGIq8","privacy_text_para":"PrivacyPolicy_privacy_text_para__uflwh"};